<template>
	<div v-if="show" class="invalidUser fullscreen-centered always-on-top dark-stars">
		<div class="closeButton"><a href="#" v-on:click="close"><i class="fas fa-times"></i></a></div>
		<div class="p-1">
			<Logo/>
			<div><h2>{{ errorTitle }}</h2></div>
			<div><h5 class="error-message-text">{{ errorMessage }}</h5></div>
			<div class="button-row">
				<button :class="resolvedCloseBtnClass" v-on:click="close">{{ btnText ? btnText : "Try Again" }}</button>
				<button v-if="showProceedBtn" :class="proceedBtnClass" v-on:click="$emit('proceed')">{{ proceedBtnText }}</button>
			</div>
		</div>
	</div>
</template>

<script>
import Logo from "@/components/Logo.vue";

export default {
	name: 'ErrorPopup',
	components: {
		Logo
	},
	props: {
		show: {
			type: Boolean,
			required: true
		},
		errorTitle: {
			type: String,
			default: "Error"
		},
		errorMessage: {
			type: String,
			required: true
		},
		backBtnText: {
			type: String,
			default: "Back"
		},
		btnText: {
			type: String,
			default: "Try Again"
		},
		closeBtnClass: {
			type: String,
			default: null
		},
		showProceedBtn: {
			type: Boolean,
			default: false
		},
		proceedBtnText: {
			type: String,
			default: "Proceed"
		},
		proceedBtnClass: {
			type: String,
			default: "blue"
		}
	},
	computed: {
		resolvedCloseBtnClass() {
			if (this.closeBtnClass !== null) {
				return this.closeBtnClass;
			}
			return this.showProceedBtn ? 'grey' : 'blue';
		}
	},
	methods: {
		close() {
			this.$emit('close');
		},
	}
}
</script>

<style scoped>
.error-message-text {
	white-space: pre-wrap;
}
</style>
